//
// class for number data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';
import { Localizer } from '../../localize/localizer';

import { DataFormatNumber } from './DataFormatNumber';

// See Numeral.js - http://numeraljs.com/
import numeral from 'numeral';

/**
 * Data formatter for percent types.
 * Data stored as a decimal and displayed as a percent.
 * @ignore
 */
export class DataFormatYear extends DataFormatNumber {
    getName(): string {
        return 'year';
    }

    /* Currency is stored internally as USD */
    getUnitText(options?: DataFormatterOptions): string {
        return '';
    }

    /* Default options for the number formatter */
    initializeOptions(): DataFormatterOptions {
        return {
            format: '####',
        };
    }

    /*
    Format data as a number.
    Options can have format='<numeral js template>'
    */
    format(data: any, options?: DataFormatterOptions, refObj?: any): string {
        let result = DataTools.getNumber(data);
        if (!result || result < 1) return '0000';
        if (result < 32) result += 2000;
        if (result < 99) result += 1900;
        let formatValue = numeral(result).format('####');
        return formatValue;
    }

    unformat(data: any): any {
        if (data === undefined) return undefined;
        if (data === null) return undefined;
        if (data === '') return undefined;
        // if data is Date() or Date.toISOString(), return year value
        if (DataTools.getMoment(data)) return new Date(data).getFullYear();

        let result = DataTools.getNumber(this.format(data, {}, null));
        return result;
    }

    validate(
        data: any,
        options?: DataFormatterOptions,
        refObj?: any,
    ): DataFormatterType.ValidationError | undefined {
        let value = this.unformat(data);
        if (value === undefined) return undefined;
        return undefined;
    }
}

export default DataFormatYear;
